<ol class="breadcrumb">
  <li><a routerLink="">Home</a></li>
  <li>
    <a [routerLink]="[url]" [queryParams]="queryParams">Voltar</a>
  </li>
  <li *ngFor="let breadcrumb of breadcrumbs">
    <a [routerLink]="[breadcrumb.url, breadcrumb.params]">{{ breadcrumb.label }}</a>
  </li>
</ol>